import React from "react";
import "./Navbar.scss";
import { Link as LinkS } from "react-scroll";
import { ReactComponent as MenuIcon } from "../../assets/menuicon.svg";

const Navbar = ({ toggle }) => {
  return (
    <div className=" flex items-center justify-center bg-gray-800 z-40  fixed w-full top-0">
      <div className="flex justify-between h-20 w-full text-white max-w-6xl shadow-md">
        <div className="flex justify-self-start items-center ml-6 font-bold">
          <LinkS to="hero" spy={true} smooth={true} offset={-70} duration={800}>
            <span>Yusuph</span>
          </LinkS>
        </div>
        <div className="flex items-center ">
          <div className="hidden lg:flex text-center md:flex space-x-6 mr-5 cursor-pointer nav-item">
            <LinkS
              to="about"
              spy={true}
              smooth={true}
              exact="true"
              offset={-80}
              duration={500}
              activeClass="active"
            >
              About
            </LinkS>
            <LinkS
              to="workflow"
              spy={true}
              exact="true"
              smooth={true}
              offset={-80}
              duration={500}
              activeClass="active"
            >
              WorkFlow
            </LinkS>
            <LinkS
              to="skills"
              exact="true"
              spy={true}
              smooth={true}
              offset={-80}
              duration={500}
              activeClass="active"
            >
              Tech I Use
            </LinkS>
            <LinkS
              to="potfolio"
              spy={true}
              exact="true"
              smooth={true}
              offset={-80}
              duration={500}
              activeClass="active"
            >
              Potfolio
            </LinkS>

            <LinkS
              to="contact"
              spy={true}
              smooth={true}
              exact="true"
              offset={-80}
              duration={500}
              activeClass="active"
            >
              Contact
            </LinkS>
          </div>
        </div>
        <div
          className=" flex mr-6 items-center  md:hidden justify-center  font-bold cursor-pointer text-red-400 "
          onClick={toggle}
        >
          <MenuIcon />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
